import React from 'react';
import { NativeFormElement, NativeFormElementSpecs, NativeFormElementType } from './store';
import { ControlPanelToggleButton } from '../components/control-panel/toggle-button';
import { functionNoop } from 'src/utils/function/noop';
import { Nullable } from 'src/types/nullable.type';
import { NeueAddMapBlockStrongIcon, NeueContentsListStrongIcon, TextStrongIcon } from 'src/monet/icons';
import { ComponentProps } from 'react';

export const NativeFormElementInitialValuesFactory = (
  type: NativeFormElementType,
  label: string,
  specs: NativeFormElementSpecs
): NativeFormElement => {
  if (type === 'input') {
    return {
      type: 'input',
      inputType: 'text',
      id: specs.uuid,
      required: false,
      value: '',
      description: '',
      label,
      ...specs,
    };
  }

  if (type === 'checkbox') {
    return {
      type: 'checkbox',
      id: specs.uuid,
      required: false,
      orientation: 'vertical',
      label,
      value: [],
      options: [
        { label: 'Checkbox 1', value: 'checkbox-1' },
        { label: 'Checkbox 2', value: 'checkbox-2' },
      ],
      description: '',
      ...specs,
    };
  }

  return {
    type: 'dropdown',
    id: specs.uuid,
    label,
    value: '',
    required: false,
    description: '',
    options: [
      { label: 'Option 1', value: 'option-1' },
      { label: 'Option 2', value: 'option-2' },
    ],
    ...specs,
  };
};

export const NativeFormElementPlaceholderFactory =
  (type: NativeFormElementType) =>
  ({ label }: { label: string }) => {
    let Icon: (props: ComponentProps<'svg'>) => Nullable<JSX.Element> = () => null;
    if (type === 'input') {
      Icon = TextStrongIcon;
    } else if (type === 'checkbox') {
      Icon = NeueAddMapBlockStrongIcon;
    } else if (type === 'dropdown') {
      Icon = NeueContentsListStrongIcon;
    }
    return (
      <ControlPanelToggleButton
        className='flex-row-reverse w-36 truncate'
        labelClassName='w-[calc(100%-20px)]'
        icon={<Icon />}
        label={label}
        onClick={functionNoop}
        selected={false}
      />
    );
  };
